import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';

import { PlaceDetail } from '../../../../services/locations.service';
import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { EditorHostService } from '../workspace/editor-host.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { SUBURB_TABS } from '../workspace/panel';
import { PagePublisherService } from '../workspace/page-publisher.service';
import { SuburbDetailService } from '../workspace/suburb-detail.service';
import { SuburbPlacesService } from '../workspace/suburb-places.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';

/**
 * The workspace's side panel (#256): its title, a suburb's tabs, and the body for whatever WorkspaceState.panel is
 * (panel.ts). A content editor (page or region) mounts in the body in place of the panel's own content. Adding a
 * panel: README.md.
 */
@Component({
  selector: 'section[app-suburb-side-panel]',
  templateUrl: './suburb-side-panel.component.html',
  styleUrls: ['./suburb-side-panel.component.scss'],
})
export class SuburbSidePanelComponent implements OnInit, OnDestroy {
  @ViewChild('editorHost', { read: ViewContainerRef, static: true }) editorHost!: ViewContainerRef;

  readonly tabs = SUBURB_TABS;

  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public detail: SuburbDetailService,
    public places: SuburbPlacesService,
    public publisher: PagePublisherService,
    public editor: EditorHostService,
    public nav: PanelNavService,
    private el: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    this.editor.attach(this.editorHost);
    this.nav.attachPanel(this.el.nativeElement);
  }

  ngOnDestroy(): void {
    this.editor.detach();
    this.nav.attachPanel(null);
  }

  /** The selected place's name, for the place panel's title. */
  get placeName(): string {
    const id = this.state.panel?.kind === 'place' ? this.state.panel.locationId : null;
    return this.places.places.find((p) => p.locationId === id)?.name ?? 'Place';
  }

  /** The number on "Our data": the suburb's notes, internal and public. */
  get notesCount(): number {
    const n = this.detail.detail?.notes;
    return (n?.internal || 0) + (n?.public || 0);
  }

  onPlaceChanged(d: PlaceDetail): void {
    this.places.placeChanged(d);
  }
}
